import { createBrowserRouter, type RouteObject } from 'react-router-dom';

import { NotFoundPage } from '@/pages/errors/not-found.page';
import { ServerErrorPage } from '@/pages/errors/server-error.page';

import { protectedRoutes } from './protected.routes';
import { publicRoutes } from './public.routes';
import { RootLayout } from './root-layout';

// Dev-only component gallery; the branch is statically false in prod builds,
// so the page is tree-shaken out of the bundle.
const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      {
        path: '/dev/components',
        lazy: async () => {
          const m = await import('@/pages/dev/component-gallery.page');
          return { Component: m.ComponentGalleryPage };
        },
      },
    ]
  : [];

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    children: [
      ...publicRoutes,
      ...protectedRoutes,
      ...devRoutes,
      { path: '/500', Component: ServerErrorPage },
      { path: '*', Component: NotFoundPage },
    ],
  },
]);
